// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/blocks.js';

import { paths } from '../generated/blocks';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('blocks', Original, paths);
